import React, { Component } from 'react'
import PropTypes from 'prop-types';
const {
    bool,
    number,
    string,
    func,
    object,
    oneOf,
    shape,
    any,
    oneOfType,
} = PropTypes;
import { injectIntl, FormattedMessage } from 'react-intl';
import { _setIntlObject } from '../localintl';

import { connect } from 'react-redux'
import {
    fetchPostsIfNeeded,
    invalidateSubreddit
} from './actions'
function mapStateToProps(state) {
    return {
        ...state.posts
    }
}

class  AsyncAppHOC extends Component {
    constructor(props,context) {
        super(props)
        console.log(context,'context')
        _setIntlObject(context.intl)
    }
    static contextTypes = {
        intl:shape({
            formatMessage:func.isRequired
        })
    }
    componentWillMount(){
        console.log(this.context.intl,'intl')
    }
    componentDidMount(){
    }
    handleGetDate=(subreddit,callback) =>{
        const { dispatch ,} = this.props;

        dispatch(invalidateSubreddit(subreddit));
        dispatch(fetchPostsIfNeeded(subreddit,callback))
    }

    render() {
        const { render,...other} = this.props;
        return (
            <div>
                {this.props.render({getDate:this.handleGetDate,...other})}
            </div>
        )
    }
}
export default connect(mapStateToProps)(AsyncAppHOC)